pushHashPath